var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-row",class:{gutters: _vm.layout.gutters}},_vm._l((_vm.layout.zones),function(zone){return _c('TgpZone',{key:zone.name,attrs:{"zone":zone,"url-config":_vm.urlConfig}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }